<script>
  import { onDestroy, onMount } from "svelte";
  import Image from "../Image.svelte";
  import { sineInOut } from "svelte/easing";
  import Intersection from "$lib/Intersection.svelte";
  import { tweened } from "svelte/motion";

  export let block;

  let panorama;
  let autoscroll = true;
  let interval;
  let left = 0;
  let newLeft = 0;
  let intersecting = false;

  export const scrollTs = () => ({
    duration: 8000,
    delay: 0,
    easing: sineInOut,
    tick: (t, u) => {
      if (!panorama || !autoscroll) return;
      panorama.scrollLeft = newLeft - u * (newLeft - left);
    },
  });

  let transition;
  let index = 1;
  let max;
  let scrollTween;

  const fn = () => {
    if (!autoscroll) {
      clearInterval(interval);
      return;
    }
    left = newLeft;
    newLeft = index % 2 === 0 ? 0 : max;

    if (scrollTween) scrollTween.set(newLeft);
    else {
      scrollTween = tweened(left, scrollTs());
      scrollTween.subscribe((value) => {
        if (panorama && autoscroll) {
          panorama.scrollLeft = value;
        }
      });
      scrollTween.set(newLeft);
    }

    index++;
  };

  const resize = () => {
    if (!panorama) return;
    if (scrollTween) scrollTween.set(panorama.scrollLeft);
    autoscroll = true;
    clearInterval(interval);
    const w = panorama.clientWidth;
    const sw = panorama.scrollWidth;
    left = sw / 2 - w / 2;
    newLeft = left;
    panorama.scrollLeft = left;

    max = sw - w;

    fn();
    interval = setInterval(fn, 9000);
  };

  onMount(resize);

  onDestroy(() => clearInterval(interval));

  const cancelAuto = () => {
    autoscroll = false;
    clearInterval(interval);
    if (scrollTween) scrollTween.set(panorama.scrollLeft);
  };

  $: if (!intersecting && !autoscroll) {
    resize();
  }

  let touches = [];
</script>

<svelte:window on:resize={resize} />
<Intersection bind:intersecting once={false}>
  <div
    class="overflow-x-scroll panorama {block.primary.top_margin
      ? ''
      : '-mt-32'}"
    bind:this={panorama}
    on:wheel={(e) => {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 1)
        cancelAuto();
    }}
    on:touchstart={(e) => (touches = e.touches)}
    on:touchend={(e) => (touches = e.touches)}
    on:touchmove={(e) => {
      const deltaX = Math.abs(e.touches[0].pageX - touches[0].pageX);
      const deltaY = Math.abs(e.touches[0].pageY - touches[0].pageY);
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 20)
        cancelAuto();
    }}
  >
    <div class="flex-shrink-0">
      <Image image={block.primary.panorama} />
    </div>
  </div>
</Intersection>

<style lang="postcss">
  .panorama {
    -ms-overflow-style: none;
    scrollbar-width: none;
    & > div {
      width: 300%;
      @screen md {
        & {
          width: 200%;
        }
      }
      @screen lg {
        & {
          width: 150%;
        }
      }
    }
  }
  .panorama::-webkit-scrollbar {
    display: none;
  }
</style>
